<template>
  <div v-if="error">
    {{ error }}
  </div>
  <Suspense v-else>
    <template #default>
      <LessonView :lessonName="lessonName" />
    </template>
    <template #fallback>
      <div>Lädt...</div>
    </template>
  </Suspense>
</template>

<script>
import {onErrorCaptured, ref} from 'vue'

export default {
  name: 'LessonSuspense',
  props: ['lessonName'],
  setup() {
    const error = ref(null)
    onErrorCaptured(e => {
      error.value = e
      return true
    })
    return {error}
  }
}
</script>
